import {
  MarkAllNotificationsSeenResponseDto,
  NotificationDto,
  PagedNotificationsRequestDto,
  PagedNotificationsResponseDto,
} from "@repo/api/notification";
import { z } from "zod";
import { AmplifilesClient } from "./api-client";

export class NotificationApi {
  static async listNotificationsPaged(params: PagedNotificationsRequestDto) {
    const response = await AmplifilesClient.instance.post(
      `/notification/paged`,
      params,
    );
    return PagedNotificationsResponseDto.parse(response.data);
  }

  static async listUnseenNotifications() {
    const response =
      await AmplifilesClient.instance.post(`/notification/unseen`);
    return z.array(NotificationDto).parse(response.data);
  }

  static async markNotificationSeen(notificationExternalId: string) {
    const response = await AmplifilesClient.instance.post(
      `/notification/${notificationExternalId}/seen`,
    );
    return NotificationDto.parse(response.data);
  }

  static async markAllNotificationsSeen() {
    const response = await AmplifilesClient.instance.post(
      `/notification/seen-all`,
    );
    return MarkAllNotificationsSeenResponseDto.parse(response.data);
  }

  static async deleteNotification(notificationExternalId: string) {
    const response = await AmplifilesClient.instance.post(
      `/notification/${notificationExternalId}/delete`,
    );
    return NotificationDto.parse(response.data);
  }
}
